import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo,
  faChartBar,
  faEye,
  faInfoCircle,
  faTrashAlt,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../layout/datatableConstants";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";



function removeLease(id, setTableKey) {
  confirmAlert({
    title: "Confirm to delete",
    message: "Are you sure you want to delete this item ?.",
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/close-deal/delete?id=` + id,
            data: { "id": id },
          }).then(function (response) {
            //console.log(ths, "ths")
            //ths.resetCounter();
            //ths.loadLeaseCountStatuswise();
            console.log("setting key", setTableKey);
            setTableKey(Math.random());
            window.location.href = window.location.href;
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          console.log("cancel clicked");

        },
      },
    ],
  });
}

function DeleteBtn(props) {
  return (
    // (props.status == 0 && props.is_dropped == 0) && (
    <span
      className="tableActionDelete"
      onClick={() => removeLease(props.deal_id, props.setTableKey)}
    >
      <FontAwesomeIcon icon={faTrashAlt} />
    </span>
    // )
    //   <>
    //   <span
    //     className="tableActionDelete"
    //     onClick={() => removeLease(props.id, props.ths)}
    //   >
    //     <FontAwesomeIcon icon={faTrashAlt} />
    //   </span>
    // </>
  );
}

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const LeaseListingTable = ({ ths, deal_id, asset, brand, status, stateId }) => {
  //console.log(asset);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [tableKey, setTableKey] = useState(0)
  const [leaseId, setLeaseId] = useState(0);
  const [popupKey, setpopupKey] = useState(0);
  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);



  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/close-deal/get-all-deals?stateId=${stateId}&asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}&status=${status}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/close-deal/get-all-deals?stateId=${stateId}&asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1&status=${status}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalGraphOpen, setGraphOpen] = React.useState(false);

  function openFromParent() {
    setIsOpen(true);
  }

  function modalGraphClose() {
    setGraphOpen(false);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Asset Type",
      selector: "asset_type",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Asset Name",
      selector: "asset_name",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Deal Type",
      selector: "deal_type",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Location",
      selector: "location",
      sortable: false,
      grow: 1,
      wrap: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: false,
      grow: 2,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Action",
      grow: 3,
      sortable: false,
      cell: (record) => {
        return (
          <div>
            <span className="tableActionEdit">
              <Link to={`/close-deals/asset-details/${record.deal_id}`}>
                {" "}
                <FontAwesomeIcon icon={faPen} />
              </Link>
            </span>

            <DeleteBtn
              status={record.status}
              deal_id={record.deal_id}
              is_dropped={record.is_dropped}
              ths={ths}
              setTableKey={setTableKey}
            >
            </DeleteBtn>


          </div>
        );
      },
    },
  ];

  return (
    <div className="parentContainer viewLease p-0">
      <div className="absoluteItemForTopBar">
        <div className="new_breadcrumbs_design">
          <ul className="d-flex align-items-center gap-3 p-0 m-0">
            <li> <Link to="/outflow">Outflow</Link> </li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <Link className="create_lease_landlord" to={"/close-deals/asset-details"} > Create </Link>
          </ul>
        </div>
      </div>

      <div className="tableContainer">
        <DataTable

          key={tableKey}
          columns={columns}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>

    </div>
  );
};
export default LeaseListingTable;
